export const GET_RESET_STATUS = "GET_RESET_STATUS";
export const SET_RESET_STATUS = "SET_RESET_STATUS";
